import React from 'react'
import assets from '../../utils/assets';
import styles from "../../pages/pages.module.scss";

const HeroSection = () => {
  return (
    <>
      <div className="landinghero ">
        <div className="container landingheromargin">
          <div className={`row ${styles.toolaHHero}`}>

            <div className={`col-12 col-lg-6 ${styles.toolaHContent}`}>
              <div className={`${styles.heroStarBtn}`}>
                <img src={assets.starWhite} alt="landing" />
                <label>Welcome to modern finance</label>
              </div>

              <div className={styles.herosectionname}>
                <h1 className={styles.herohaed}>
                  Effortless <br /> Accounting, Tax <img src={assets.arc} alt='' />{" "} <br />& payroll for<br />Ambitious founders
                </h1>

                <div className={styles.herosub}>
                  <h4>Software + Services that help you grow faster with 100% compliance </h4>
                </div>

                <div className={styles.demoHeroBtn}>
                  See Demo
                </div>
              </div>
            </div>

            <div className="col-12 col-lg-6 d-flex justify-content-center align-items-center">
              <img className="img-fluid" src={assets.DesktopImg} alt='' />
            </div>

          </div>
        </div>
      </div>
    </>
  )
}

export default HeroSection;